import { render, staticRenderFns } from "./TendersNavigation.vue?vue&type=template&id=120ad509&"
import script from "./TendersNavigation.vue?vue&type=script&lang=js&"
export * from "./TendersNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports